import { CSSProperties, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { EvaluationLimits } from '../../util/evaluationContract';
import { formatScore } from '../../util/evaluationFormat';
import { SCORE_BAR } from '../../util/evaluationStatusMeta';
import styles from './page-supplier-evaluations.module.scss';

export type ScoreBarRow = {
  key: string;
  label: string;
  score: number | null;
  count: number;
};

type Props = {
  rows: ScoreBarRow[];
};

const widthOf = (score: number | null) =>
  score === null ? '0%' : `${(score / EvaluationLimits.ScaleMax) * 100}%`;

const ScoreBarList: FC<Props> = ({ rows }) => {
  const [t] = useTranslation('evaluations');

  return (
    <ul className={styles.bars}>
      {rows.map(row => (
        <li key={row.key}>
          <div className={styles.barHeader}>
            <span>
              {row.label}
              <span className={`${styles.muted} ${styles.small}`}>
                {' · '}
                {t('supplierScore.answerCount', {
                  count: row.count,
                  defaultValue_one: '{{count}} svar',
                  defaultValue_other: '{{count}} svar',
                })}
              </span>
            </span>
            <span className={styles.barValue}>{formatScore(row.score)}</span>
          </div>
          <div className={styles.barTrack} style={{ '--bar-track': SCORE_BAR.track } as CSSProperties}>
            <div
              data-score-bar-fill=""
              className={styles.barFill}
              style={
                {
                  width: widthOf(row.score),
                  '--bar-fill':
                    row.count >= SCORE_BAR.minAnswers ? SCORE_BAR.fill : SCORE_BAR.fewAnswersFill,
                } as CSSProperties
              }
            />
          </div>
        </li>
      ))}
    </ul>
  );
};

export default ScoreBarList;
